import React from 'react';
import Thunder from '../../../static/images/utils/thunder.svg'
import Container from "../../Wrappers/Container";

const DashboardSuscription = () => {
  return (
    <Container className="s-column">
      <h3 className="s-mb-0">Tu suscripción</h3>
      <div className="s-center s-column flex-grow">

        <div className="flex flex-grow s-main-center s-py-16px">
          <img
            src={Thunder}
            alt="Rayito de la suscripción"
          />
        </div>

        <div className="s-to-bottom">
          <p className="t4 s-color-blue s-mb-8px">Súper premium</p>
          <p className="s-mb-0 smaller">Se renovará el <span className="s-color-title">20 de enero del 2021</span></p>
        </div>
      </div>
    </Container>
  );
};

export default DashboardSuscription;
